import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import UprezShareForm from '../../../components/Share/UprezForm';
import DriveItemUtils from '../../../utils/driveItem';
import RoutesUtils from '../../../utils/routes';
import { RoutePath } from '../../../routes/constants';
import { StyleColor } from '../../../utils/styles-constants';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		sharePanel,
		routerParamsHistory,
		profile,
	} = state;
	const {
		form,
		isOpen,
		isShareActionsPopupOpen,
		isProcessing,
		isPublicationShare,
		selectedResources,
		selectedNotes,
		foldersContent,
		callbackAction,
	} = sharePanel;
	const isCreateDealAvailable = [...selectedResources, ...foldersContent].some(item => (
		DriveItemUtils.isProposal(item.format))
	);
	const currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
	const isEditorOpened = currentRoute.includes(RoutePath.Editor);

	return {
		form,
		selectedResources,
		selectedNotes,
		isOpen,
		isShareActionsPopupOpen: isShareActionsPopupOpen && !isPublicationShare,
		isProcessing,
		isCreateDealAvailable,
		actionButtonColor: isEditorOpened ? StyleColor.Blue600 : '',
		isReadOnlyApp: Utils.isReadOnlyApp(profile.role),
		callbackAction,
	};
};

export default connect(mapStateToProps)(UprezShareForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/UprezForm/index.tsx